import React, { useState } from 'react'
import { toast } from "react-toastify";
import PropTypes from "prop-types";
// import { invoiceRequest } from '../../hooks/fetch-hooks/invoice-calls/invoice';
import { request } from '../../config/helpers/axios-instance';
import { useModalMain } from '../../contexts/modal';
import { getTenantId } from '../../utils/helpers';
import { TENANT_COMPANY_MAP } from '../../utils/constants';
import EvitalDuplicateResolution from './EvitalDuplicateResolution';


function InvoiceForm(id) {
    const tenantId = getTenantId();
    const defaultState = tenantId === TENANT_COMPANY_MAP.EAZY ? 'INV-D-1000-' : '';
    const [value, setvalue] = useState(defaultState)
    const { openModal, closeModal } = useModalMain()

    async function Submit(e, id) {
        e.preventDefault()
        const body = { userOrderId: id };

        if (tenantId === TENANT_COMPANY_MAP["EAZY"]) {
            body.hinaiInvoiceNo = value;
        } else {
            body.eVitalRXOrderNo = value;
        }

        const response = await request({
            method: "POST",
            url: tenantId === TENANT_COMPANY_MAP["EAZY"] ? `hinai/userorder` : `evitalrx/userorder`,
            data: body
        })

        const responseData = response?.data?.data;

        // Duplicate inventoryId items found -> let the user pick the right ones.
        if (response?.data?.success && responseData?.requiresResolution) {
            openModal(() => (
                <EvitalDuplicateResolution
                    duplicates={responseData.duplicates}
                    userOrderId={id}
                    eVitalRXOrderNo={value}
                />
            ));
            return;
        }

        if (response?.data?.success) {
            toast.success("Request Successful");
            closeModal()
        }
        if (!response?.data?.success) {
            toast.error(response?.data?.error || "Something went wrong")
        }
    }

    return (
        <>
            <div className='p-5'>
                <h1 className='text-3xl text-black my-3 font-bold'>Invoice Generation</h1>
                <form onSubmit={(e) => Submit(e, id)}>
                    <input type="text" required={true} minLength={7} placeholder='Order Number' value={value} onChange={(e) => setvalue(e.target.value)} className=" w-full border-2 border-white-500 rounded-2xl mb-3" />
                    <button type='submit' className="w-full bg-elm-500 text-white-100 hover:bg-elm-700 font-semibold font-sans py-2 rounded-2xl">Submit</button>
                </form>
            </div>
        </>
    )
}

export default InvoiceForm

InvoiceForm.propTypes = {
    id: PropTypes.number
}